/**
 * Influencer Analytics by Wednesday (formerly Upfluence) — creator analytics overlay
 *
 * Declares one web-accessible-resource entry listing six named files (SVG/GIF assets plus
 * assets/iframe.html and assets/iframe.js), matched to every origin with no dynamic URL.
 * The vendor-named upfluence-blue-logo.svg is the cleanest signal — an image loads through
 * probeImage with no CORS grant, so it survives a restrictive page CSP.
 *
 * Manifest verified against version 3.0.0.4.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nogempgplicnckhcmgjjjgflmipmbgaf';

export const influencerAnalytics: ExtensionDefinition = {
  id: ID,
  name: 'Influencer Analytics by Wednesday',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Six named static WAR on every origin with no dynamic URL, including the vendor-named ' +
    'upfluence-blue-logo.svg. Detection is CORS-free and conclusive.',
  signals: [
    {
      id: 'war-upfluence-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/upfluence-blue-logo.svg via <img> — a vendor-named logo exposed to ' +
        'every origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/upfluence-blue-logo.svg'),
    },
    {
      id: 'war-quick-opener-svg',
      kind: 'web-accessible-resource',
      description:
        'Load assets/quick-opener.svg via <img> — a second bundled icon corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/quick-opener.svg'),
    },
    {
      id: 'war-iframe-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/iframe.html — the injected overlay entry point, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/iframe.html'),
    },
  ],
};
